(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ts-mobile-header"] && !Shopify.designMode) return;
  try {
    (function () {
  function initializeCategoryTabs(scope) {
    var menus = scope.querySelectorAll('.ts-mobile-category-menu');

    menus.forEach(function (menu) {
      if (menu.dataset.categoryTabsReady === 'true') return;

      var tabs = Array.from(menu.querySelectorAll('[data-ts-category-tab]'));
      var panels = Array.from(menu.querySelectorAll('[data-ts-category-panel]'));

      if (!tabs.length || tabs.length !== panels.length) return;

      function activateTab(nextTab, moveFocus) {
        var panelId = nextTab.getAttribute('aria-controls');

        tabs.forEach(function (tab) {
          var isSelected = tab === nextTab;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.id !== panelId;
        });

        if (moveFocus) nextTab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(tab, false);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;

          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        });
      });

      menu.dataset.categoryTabsReady = 'true';
    });
  }

  initializeCategoryTabs(document);

  document.addEventListener('shopify:section:load', function (event) {
    initializeCategoryTabs(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
